<div class="container mt-3">
  <div [formGroup]="formGroup" class="container mt-3">
  @if (guest && reservation) {
  <section id="data-resumen">
    <div class="row">
      <div class="col">
        {{ "privacy_form.guest_details.checkin_number" | translate }}:
      </div>
      <div class="col">
        <span data-result-detail="reservation" *ngIf="reservation.id">{{
          reservation.id
        }}</span>
      </div>
    </div>
    <div class="row my-2">
      <div class="col">
        {{ "privacy_form.guest_details.name" | translate }}:
      </div>
      <div class="col">
        <span *ngIf="reservation?.guests?.length" data-result-detail="name">{{
          (guest.firstName | titlecase) + " " + (guest.lastName | titlecase)
        }}</span>
      </div>
    </div>
    <div *ngFor="let control of controlArray">
      @if (mustShowFields(control)) {
      <div class="row my-2">
        <div class="col">
          {{ "privacy_form.guest_details."+ control.name | translate }}:
        </div>

        <div class="col" >
          <div class="col position-relative">
            @if (isForPdf) {
            <span>{{formValues[control.name]}}</span>
            }@else {
              @if (control.type === 'select') {
                <select
                    data-input="control.name"
                    *ngIf="control"
                    id="{{control.name}}"
                    name="{{control.name}}"
                    class="form-control form-control-sm"
                    [ngClass]="{'is-invalid': isInvalid(control.control)}"
                    [formControl]="control.control"
                  >
                    <option value="0" >{{ 'privacy_form.'+control.name+'_placeholder' | translate }}</option>
                    <option *ngFor="let item of selectsObject[control.name]" [value]="item.value">{{
                      item.type
                    }}</option>
                    {{control.control.value}}
                </select>
              } @else if (control.type === 'text' || control.type === 'tel' || control.type === 'email' )  {
                <input
                  data-input="control.name"
                  *ngIf="control"
                  type="{{control.type}}"
                  id="{{control.name}}"
                  name="{{control.name}}"
                  class="form-control form-control-sm"
                  [ngClass]="{'is-invalid': isInvalid(control.control)}"
                  [formControl]="control.control"
                  placeholder="{{ 'privacy_form.'+control.name+'_placeholder' | translate }}"
                />
              }
            }
            <div class="invalid-feedback" *ngIf="isInvalid(control.control)">
              {{ getFormControlErrorMessage(control.control) | translate:{ requiredLength: control.control.errors?.['minLength']?.requiredLength } }}
            </div>
          </div>
        </div>
      </div>
      }
    </div>

    <div formArrayName="vehicles" *ngIf="isMultipleVehiclesActive">
      <div *ngFor="let vehicleGroup of vehiclesFormArray.controls; let i = index" [formGroupName]="i" class="mb-3">
        <div class="row my-2" [ngClass]="{'my-2': vehicleGroup.get('_isPlatePreloaded')?.value}">
          <div class="col fs-6">
            {{ ('privacy_form.guest_details.vehicle' | translate) }} {{ vehiclesFormArray.length > 1 ? (i + 1) : '' }}
          </div>
          <div class="col" *ngIf="vehicleGroup.get('_isPlatePreloaded')?.value">
            <span data-result-detail="vehiclePlateCode" *ngIf="vehicleGroup.get('plateCode')?.value">
              {{ getVehicleName(vehicleGroup.get('typeId')?.value )}}: {{ vehicleGroup.get('plateCode')?.value }}
            </span>
          </div>
        </div>
        <div class="row align-items-center mt-2 mb-2 pb-2" *ngIf="vehicleTypeOptions.length && !vehicleGroup.get('_isPlatePreloaded')?.value">
          <div class="col-md-6 d-flex flex-wrap gap-2">
            <ng-container *ngFor="let option of vehicleTypeOptions; let j = index">
              <div class="form-check form-check-inline text-center m-0 mt-2 mb-2">
                <input
                  class="form-check-input d-none"
                  type="radio"
                  [id]="'vehicleType' + i + option.id"
                  [value]="option.typeId"
                  formControlName="typeId"
                  [attr.aria-label]="option.name | translate"
                  [title]="option.name | translate"
                  [attr.data-vehicle-type]="option.typeId"
                  [attr.data-vehicle-name]="option.name"
                  [attr.data-vehicle-icon]="getVehicleIcon(option.name)"
                  [attr.data-vehicle-index]="i"
                  [attr.data-vehicle-option-index]="j"
                />
                <label
                  class="btn btn-outline-secondary"
                  [for]="'vehicleType' + i + option.id"
                  [class.selected]="vehicleGroup.get('typeId')?.value === option.typeId"
                  [attr.aria-label]="option.name | translate"
                  [title]="option.name | translate"
                    [class.disabled]="!!vehicleGroup.get('plateCode')?.value && vehicleGroup.get('_isPlatePreloaded')?.value"

                >
                  <i [ngClass]="getVehicleIcon(option.name)" class="2x" role="img" [attr.aria-label]="option.name | translate"></i>
                </label>
              </div>
            </ng-container>
          </div>

          <div class="col-md-6 mt-2">
            <div class="d-flex align-items-center">
                <label for="plateCode-{{i}}" class="form-label me-2 mb-0 w-25">
                  {{ 'privacy_form.guest_details.plateCode' | translate }}:
                </label>
                <input
                  maxlength="15"
                  id="plateCode-{{i}}"
                  formControlName="plateCode"
                  class="form-control form-control-sm"
                  placeholder="{{ 'privacy_form.plateCode_placeholder' | translate }}"
                  [readonly]="vehicleGroup.get('_isPlatePreloaded')?.value"
                  [ngClass]="{
                    'form-control form-control-sm': true,
                    'is-invalid': isInvalid(vehicleGroup.get('plateCode'))
                  }"
                />
              </div>
              <div class="invalid-feedback d-block" *ngIf="isInvalid(vehicleGroup.get('plateCode'))">
                {{ getFormControlErrorMessage(vehicleGroup.get('plateCode')) | translate:{ requiredLength: vehicleGroup.get('plateCode')?.errors?.['minLength']?.requiredLength } }}
              </div>
          </div>
        </div>
      </div>
      </div>
    <hr class="my-4" />
    <div class="row">
      <div class="col">
        {{ "privacy_form.guest_details.room" | translate }}:
      </div>
      <div class="col">
        <span data-result-detail="roomName" *ngIf="reservation?.roomName">{{
          reservation.roomName
        }}</span>
      </div>
    </div>

    <div class="row">
      <div class="col">
        {{ "privacy_form.guest_details.stay" | translate }}:
      </div>
      <div class="col">
        <span
          data-result-detail="stay"
          *ngIf="guest.checkoutDate || guest?.checkinDate"
          >{{ guest.checkinDate | date : "dd/MM/YYYY" }} -
          {{ guest.checkoutDate | date : "dd/MM/YYYY" }}</span
        >
      </div>
    </div>
    <div class="row">
      <div class="col">
        {{ "privacy_form.guest_details.composition" | translate }}:
      </div>
      <div class="col">
        <span *ngIf="reservation?.adults" data-result-detail="composition"
          >{{ reservation.adults }}
          {{ "privacy_form.guest_details.adults" | translate }}</span
        >
        <span *ngIf="reservation?.children">
          +
          {{ reservation.children }}
          {{ "privacy_form.guest_details.children" | translate }}</span
        >
      </div>
    </div>
    <div class="row" *ngIf="guest?.cityTaxAmount">
      <div class="col">
        {{ "privacy_form.guest_details.city_tax" | translate }}:
      </div>
      <div class="col">
        <span>{{
          guest.cityTaxAmount
            | currency : guest.currencyCode || "EUR" : "symbol"
        }}</span>
      </div>
    </div>
    <div class="row mt-2" *ngIf="reservation?.facilityIds?.length">
      <div class="col">
        {{ "privacy_form.guest_details.facilities" | translate }}:
      </div>
      <div class="col">
        <span>
          {{ getFacilities(reservation.facilityIds) }}
        </span>
      </div>
    </div>
  </section>
  }
  </div>
</div>
